import { render, staticRenderFns } from "./TextAreaForm.vue?vue&type=template&id=54e42b38&"
import script from "./TextAreaForm.vue?vue&type=script&lang=js&"
export * from "./TextAreaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports